import cookies from 'js-cookie';
// tools
function nodeIsAppEnvironment() {
    return !!cookies?.get('pkg') && !!cookies?.get('appver');
}

function isTiny() {
    return /^\/tiny\/.*/.test(window.location.path || '');
}

// Test
function getNotExecuteRedirectQuey(url, key) {
    const theRequest = Object.create(null);
    if (url.includes('?')) {
        const index = url.indexOf('?') + 1;
        const str = url.substr(index);
        const strs = str.split('&');
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
        }
    }
    return theRequest[key];
}

// get pwaSource
function getPwaSource(url) {
    const theRequest = Object.create(null);
    if (url.includes('?')) {
        const index = url.indexOf('?') + 1;
        const str = url.substr(index);
        const strs = str.split('&');
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
        }
    }
    return theRequest.pwa_source;
}

function isFilmHost() {
    return window.location.host === 'www.kwai.film';
}

async function getCkid(app) {
    const { status, data } = await app.$axios.$$get(`https://ads.mythad.com/rest/n/adintl/ad/getCkid`, { withCredentials: true });
    if (status === 200 && data) {
        return data;
    }
}

async function getDeviceIDByWebDid(app, webDid, ckid) {
    if (!webDid && !ckid) {
        console.log('redirect_web', 'client', 'webDid and ckid is null', webDid, ckid);
        return;
    }

    console.log('redirect_web', 'client', 'webDid & ckid', webDid, ckid);

    const baseWebdidPath = 'overseaAPI::/rest/o/w/pwa/v2/getDidByWebDid?';
    const baseCkidPath = 'overseaAPI::/rest/o/w/pwa/v2/getDidByCookieId?';
    let appendedPath;
    if (webDid) {
        appendedPath = `${baseWebdidPath}webDid=${webDid}`;
    }
    if (ckid) {
        appendedPath = `${baseCkidPath}&cookieId=${ckid}`;
    }
    const { result, data } = await app.$axios.$$get(appendedPath);
    console.log('redirect_web', 'client', 'result & data', result, data);
    let deviceId;
    let redirectAB;
    if (result === 1) {
        // const data = { redirectAB: 'share', white: 'true', deviceId: 'ANDROID_f89df9ed896e511f' };
        deviceId = data.deviceId;
        redirectAB = data.redirectAB;
        const testDevideId = getNotExecuteRedirectQuey(window.location.href, 'test_deviceId');
        const testRedirectab = getNotExecuteRedirectQuey(window.location.href, 'test_redirectab');
        if (testDevideId) {
            deviceId = testDevideId;
        }
        if (testRedirectab) {
            redirectAB = testRedirectab;
        }
    }
    return { deviceId, redirectAB };
}

export const checkWebDidCollect = () => {
    const _webDid_collect = cookies.get('_webDid_collect');
    if (!_webDid_collect) {
        cookies.set('_webDid_collect', 1);
        return false;
    }
    return true;
};

export const filmRedirect = async (app, retry) => {
    if (process.server || nodeIsAppEnvironment() || isTiny()) {
        return;
    }
    const reg = new RegExp(window.location.origin, 'g');
    const url = window.location.href?.replace(reg, '');
    const ignoreHost = getNotExecuteRedirectQuey(url, 'ignore_host');
    const canRedirect = isFilmHost() || ignoreHost === 'true';
    if (!canRedirect) {
        return;
    }

    const webDid = cookies?.get('webDid');
    const collect = checkWebDidCollect();
    let parsedAppDeviceId;
    if (webDid && !collect) {
        // 未种下webDid,client端执行webDid to deviceId
        parsedAppDeviceId = await getDeviceIDByWebDid(app, webDid);
        console.log('redirect_web', 'client', 'getFromWebdid', `app-device-id:${JSON.stringify(parsedAppDeviceId)}`);
    }

    let ckid;
    if (!parsedAppDeviceId || !parsedAppDeviceId.deviceId) {
        ckid = await getCkid(app); // ckid = '9e0d900c-ccbf-4e67-8c29-54ae1b6adfc0';
        parsedAppDeviceId = await getDeviceIDByWebDid(app, webDid, ckid);
        console.log('redirect_web', 'client', 'getFromCkid', `ckid:${ckid}`, `app-device-id:${JSON.stringify(parsedAppDeviceId)}`);
    }
    if (!ckid && retry) {
        setTimeout(() => {
            filmRedirect(app, false);
        }, 1000);
        console.log('redirect_web', 'client', 'ckid is null, then retry');
        return;
    }
    const { deviceId, redirectAB } = parsedAppDeviceId || {};
    let containSource = true;
    if (deviceId && redirectAB) {
        cookies.set('app_device_id', JSON.stringify({ deviceId, redirectAB, webDid, ckid }));
        const pwaSource = getPwaSource(url);
        const webRedircctArr = redirectAB.split(',');
        containSource = webRedircctArr.includes(pwaSource); // 不包含跳转
    } else if (deviceId === undefined || deviceId === '' || redirectAB === undefined || redirectAB === '') {
        // 无deviceID 跳转
        containSource = false;
        console.log('redirect_web', 'client', 'deviceID or abtest is null', deviceId, redirectAB);
    }

    console.log(
        'redirect_web',
        'client',
        'can-redirect',
        `redirect:${!containSource}`,
        `app-device-id:${JSON.stringify({ deviceId, redirectAB, webDid, ckid })}`
    );
    if (!containSource) {
        const redirectUrl = new URL(`https://www.kwai.com${url}`);
        if (webDid) {
            redirectUrl?.searchParams?.set('webDid', webDid);
        }
        if (ckid) {
            redirectUrl?.searchParams?.set('ckid', ckid);
        }
        if (deviceId) {
            redirectUrl?.searchParams?.set('deviceId', deviceId);
        }
        if (redirectUrl?.searchParams.has('ignore_host')) {
            redirectUrl?.searchParams?.delete('ignore_host');
        }
        const redirectUrlStr = redirectUrl?.toString();
        // eslint-disable-next-line no-undef
        const notRedirectV = getNotExecuteRedirectQuey(url, 'not_redirect');
        if (notRedirectV !== 'true') {
            console.log('redirect_web', 'client', 'redirect-path: ', redirectUrlStr);
            window.location.href = redirectUrlStr;
        }
        // console.log('redirect_web', 'client', 'redirect-path: ', redirectUrlStr);
    }
};
